import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { apiClient } from '@/lib/apiClient'

/** `unavailable` : plat retiré de la vente par l'équipe, quel que soit son stock. */
export type Availability = 'available' | 'low' | 'sold_out' | 'unavailable'


export interface PublicFoodCategory {
  id: string
  name: string
  description: string
  position: number
}

export interface PublicFoodItem {
  id: string
  category_id: string | null
  name: string
  description: string
  image_url: string | null
  price_minor: number
  currency: string
  allergens: string[]
  tags: string[]
  availability: Availability
  max_per_order: number | null
}

export interface PublicFoodPack {
  id: string
  name: string
  description: string
  image_url: string | null
  price_minor: number
  currency: string
  availability: Availability
  max_per_order: number | null
  /** RULE 4 : faux sauf décision explicite de l'équipe. */
  includes_admission: boolean
  contents: string[]
}

export interface PublicMenu {
  categories: PublicFoodCategory[]
  items: PublicFoodItem[]
  packs: PublicFoodPack[]
  /** Mention produite par le serveur, affichée telle quelle. */
  admission_notice: string | null
}

export function usePublicMenu(slug: string | undefined) {
  const { i18n } = useTranslation()

  return useQuery({
    queryKey: ['menu', slug, i18n.language],
    queryFn: () => apiClient.get<PublicMenu>(`/public/events/${slug}/menu`, {
      locale: i18n.language,
    }),
    enabled: Boolean(slug),
  })
}
